/* open.DASH Industrial – globales Verhalten */
(function () {
  'use strict';

  const T = window.theme || { routes: {}, settings: {}, strings: {} };

  /* ---------- Helpers ---------- */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || T.moneyFormat || '{{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function delimit(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(precision);
      const parts = num.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    let value = '';
    const match = fmt.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = delimit(cents, 2); break;
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      default: value = delimit(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
  window.theme.formatMoney = formatMoney;

  function toast(message, type, link) {
    const region = $('#ToastRegion');
    if (!region) return;
    const el = document.createElement('div');
    el.className = 'toast toast--' + (type || 'success');
    const icon = type === 'error'
      ? '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>'
      : '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4.5 4.5L19 7"/></svg>';
    el.innerHTML = icon + '<span></span>' + (link ? '<a href="' + link.href + '">' + link.label + '</a>' : '');
    el.querySelector('span').textContent = message;
    region.appendChild(el);
    setTimeout(() => { el.style.opacity = '0'; el.style.transition = 'opacity .4s'; setTimeout(() => el.remove(), 400); }, 4500);
  }
  window.theme.toast = toast;

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }
  window.theme.updateCartCount = updateCartCount;

  /* ---------- Header: Mobile-Menü & Suche ---------- */
  function initHeader() {
    const nav = $('[data-nav]');
    if (!nav) return;
    const toggle = $('[data-nav-toggle]', nav);
    if (toggle) {
      toggle.addEventListener('click', () => {
        const open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        toggle.querySelector('[data-icon-menu]').hidden = open;
        toggle.querySelector('[data-icon-close]').hidden = !open;
      });
    }
    const search = $('[data-search-overlay]');
    $$('[data-search-open]').forEach((btn) => btn.addEventListener('click', () => {
      if (!search) return;
      search.setAttribute('open', '');
      const input = $('input[type="search"]', search);
      if (input) setTimeout(() => input.focus(), 30);
    }));
    if (search) {
      $$('[data-search-close]', search).forEach((b) => b.addEventListener('click', () => search.removeAttribute('open')));
      search.addEventListener('click', (e) => { if (e.target === search) search.removeAttribute('open'); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') search.removeAttribute('open'); });
    }
  }

  /* ---------- Reveal & Pointer-Glow ---------- */
  function initEffects() {
    const cards = $$('.card, .usp-card, .pricing-card, .hero-stat, .performance-card');
    cards.forEach((el) => {
      el.addEventListener('pointermove', (e) => {
        const rect = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - rect.left) / rect.width * 100) + '%');
        el.style.setProperty('--my', ((e.clientY - rect.top) / rect.height * 100) + '%');
      });
    });

    const reveals = $$('.reveal');
    if (!reveals.length) return;
    if (!('IntersectionObserver' in window) || !document.body.classList.contains('has-reveal')) {
      reveals.forEach((el) => el.classList.add('in-view'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach((el) => io.observe(el));
    // Elemente oberhalb des Viewports sofort einblenden
    setTimeout(() => reveals.forEach((el) => { if (el.getBoundingClientRect().top < 0) el.classList.add('in-view'); }), 50);
  }

  /* ---------- Produktformular (AJAX add to cart) ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.button = this.form.querySelector('[data-add-button]');
      this.error = this.form.querySelector('[data-form-error]');
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.button || this.button.disabled) return;
      this.setLoading(true);
      if (this.error) { this.error.hidden = true; this.error.textContent = ''; }
      const fd = new FormData(this.form);
      fetch(T.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd,
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.status) {
            this.showError(data.description || data.message || T.strings.cartError);
            return;
          }
          if (T.settings.cartRedirect) { window.location.href = T.routes.cart; return; }
          return fetch(T.routes.cart + '.js').then((r) => r.json()).then((cart) => {
            updateCartCount(cart.item_count);
            toast((data.product_title || data.title) + ' – ' + T.strings.added, 'success', { href: T.routes.cart, label: T.strings.viewCart || '→' });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          });
        })
        .catch(() => this.showError(T.strings.cartError))
        .finally(() => this.setLoading(false));
    }
    showError(msg) {
      if (this.error) { this.error.textContent = msg; this.error.hidden = false; this.error.classList.add('form__message', 'form__message--error'); }
      else toast(msg, 'error');
    }
    setLoading(state) {
      this.button.classList.toggle('btn--loading', state);
      this.button.setAttribute('aria-busy', String(state));
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* ---------- Varianten- und Abo-Auswahl ---------- */
  // Preis/Button einer Produktsektion für Variante + gewählten Selling Plan aktualisieren
  function readVariants(section) {
    const json = section.querySelector('[data-variants]');
    if (!json) return null;
    try { return JSON.parse(json.textContent); } catch (e) { return null; }
  }
  function selectedPlanId(section) {
    const checked = section.querySelector('input[name="selling_plan"]:checked');
    if (checked) return checked.value || null;
    const sel = section.querySelector('select[name="selling_plan"]');
    return sel && sel.value ? sel.value : null;
  }
  function updateProductState(section, variant) {
    const idInput = section.querySelector('input[name="id"]');
    const button = section.querySelector('[data-add-button]');
    const label = button ? button.querySelector('[data-add-label]') : null;
    const priceEl = section.querySelector('[data-price-amount]');
    const compareEl = section.querySelector('[data-price-compare]');
    if (!variant) {
      if (button) { button.disabled = true; if (label) label.textContent = T.strings.unavailable; }
      return;
    }
    if (idInput) idInput.value = variant.id;

    let price = variant.price;
    let compare = variant.compare_at_price;
    const planId = selectedPlanId(section);
    if (planId && Array.isArray(variant.selling_plan_allocations)) {
      const alloc = variant.selling_plan_allocations.find((a) => String(a.selling_plan_id) === String(planId));
      if (alloc) { price = alloc.price; compare = alloc.compare_at_price; }
    }
    if (priceEl) priceEl.textContent = formatMoney(price).replace(/[.,]00(?=\D|$)/, '');
    if (compareEl) {
      if (compare > price) { compareEl.hidden = false; compareEl.textContent = formatMoney(compare); }
      else compareEl.hidden = true;
    }
    // Abo-Karten: Preise der Optionen für die aktuelle Variante nachziehen
    section.querySelectorAll('[data-plan-picker] input[name="selling_plan"]').forEach((input) => {
      const priceNode = input.nextElementSibling && input.nextElementSibling.querySelector('.plan-picker__price');
      if (!priceNode) return;
      let p = variant.price;
      if (input.value && Array.isArray(variant.selling_plan_allocations)) {
        const a = variant.selling_plan_allocations.find((x) => String(x.selling_plan_id) === input.value);
        if (a) p = a.price;
      }
      priceNode.textContent = formatMoney(p).replace(/[.,]00(?=\D|$)/, '');
    });

    if (button) {
      // Nur-Abo-Shop: ohne Selling Plan für diese Variante bleibt der Button gesperrt
      const subscriptionOnly = !!section.querySelector('[data-subscription-only]');
      const hasPlan = Array.isArray(variant.selling_plan_allocations) && variant.selling_plan_allocations.length > 0;
      const canBuy = variant.available && (!subscriptionOnly || hasPlan);
      button.disabled = !canBuy;
      if (label) label.textContent = canBuy ? T.strings.addToCart : T.strings.soldOut;
    }
    if (variant.featured_media && variant.featured_media.id) {
      const thumb = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (thumb) thumb.click();
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    if (planId) url.searchParams.set('selling_plan', planId); else url.searchParams.delete('selling_plan');
    window.history.replaceState({}, '', url.toString());
  }
  function currentVariant(section) {
    const variants = readVariants(section);
    if (!variants) return null;
    const idInput = section.querySelector('input[name="id"]');
    const id = idInput ? idInput.value : null;
    return variants.find((v) => String(v.id) === String(id)) || variants[0] || null;
  }

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-product-section]') || document;
      this.variants = readVariants(this.section);
      if (!this.variants) return;
      this.addEventListener('change', this.onChange.bind(this));
    }
    selectedOptions() {
      return Array.from(this.querySelectorAll('fieldset')).map((fs) => {
        const checked = fs.querySelector('input:checked');
        if (checked) return checked.value;
        const sel = fs.querySelector('select');
        return sel ? sel.value : null;
      });
    }
    onChange() {
      const opts = this.selectedOptions();
      const variant = this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      updateProductState(this.section, variant);
    }
  }
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);

  class SellingPlanPicker extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[data-product-section]') || document;
      this.addEventListener('change', () => updateProductState(this.section, currentVariant(this.section)));
    }
  }
  if (!customElements.get('selling-plan-picker')) customElements.define('selling-plan-picker', SellingPlanPicker);

  /* ---------- Produktbilder ---------- */
  function initMedia() {
    $$('[data-media-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const main = $('[data-media-main] img');
        if (!main) return;
        main.src = btn.dataset.src;
        main.srcset = btn.dataset.srcset || '';
        main.alt = btn.querySelector('img') ? btn.querySelector('img').alt : '';
        $$('[data-media-thumb]').forEach((b) => b.setAttribute('aria-current', 'false'));
        btn.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Mengen-Buttons ---------- */
  function initQuantity() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      const wrap = btn.closest('.quantity');
      const input = wrap && wrap.querySelector('input');
      if (!input) return;
      const min = parseInt(input.min || '0', 10);
      let v = parseInt(input.value || '0', 10) + (btn.dataset.qtyChange === 'up' ? 1 : -1);
      if (v < min) v = min;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Warenkorb (Section Rendering API) ---------- */
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('change', (e) => {
        const input = e.target.closest('[data-line-qty]');
        if (input) this.change(input.dataset.lineQty, parseInt(input.value, 10));
      });
      this.addEventListener('click', (e) => {
        const rm = e.target.closest('[data-line-remove]');
        if (rm) { e.preventDefault(); this.change(rm.dataset.lineRemove, 0); }
      });
      const note = this.querySelector('[data-cart-note]');
      if (note) note.addEventListener('change', () => {
        fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
      });
    }
    change(line, quantity) {
      this.classList.add('is-loading');
      fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [this.sectionId, 'header'].join(',') }),
      })
        .then((r) => r.json())
        .then((cart) => {
          if (cart.status) { toast(cart.description || cart.message || T.strings.cartError, 'error'); return; }
          const html = cart.sections && cart.sections[this.sectionId];
          if (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('cart-page');
            if (fresh) this.innerHTML = fresh.innerHTML;
          }
          updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(() => toast(T.strings.cartError, 'error'))
        .finally(() => this.classList.remove('is-loading'));
    }
  }
  if (!customElements.get('cart-page')) customElements.define('cart-page', CartPage);

  /* ---------- Adressen (Account) ---------- */
  function initAddresses() {
    $$('[data-address-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = document.getElementById(btn.dataset.addressToggle);
        if (!target) return;
        target.hidden = !target.hidden;
        btn.setAttribute('aria-expanded', String(!target.hidden));
        if (!target.hidden) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
    $$('[data-address-delete]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!confirm(btn.dataset.confirm || '?')) return;
        const form = document.createElement('form');
        form.method = 'post';
        form.action = btn.dataset.addressDelete;
        form.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(form);
        form.submit();
      });
    });
    if (window.Shopify && Shopify.CountryProvinceSelector) {
      $$('[data-country-select]').forEach((sel) => {
        const prov = sel.dataset.provinceSelect;
        const wrap = sel.dataset.provinceWrap;
        new Shopify.CountryProvinceSelector(sel.id, prov, { hideElement: wrap });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initEffects();
    initMedia();
    initQuantity();
    initAddresses();
  });
})();
